import React, {
  useMemo,
  useState
} from 'react';

import {
  Box
} from '@mui/material';

import {
  documents
} from './data';

import PatientDocumentFilters
  from './PatientDocumentFilters';

import PatientDocumentTable
  from './PatientDocumentTable';

import {
  rootSx
} from './PatientDocumentStyles';

const PatientDocumentList = () => {
  const [statusFilter, setStatusFilter] = useState('all');
  const [category, setCategory] = useState('all');
  const [dateRange, setDateRange] = useState('6');
  const [searchText, setSearchText] = useState('');

  const filteredDocuments = useMemo(() => {
    const normalizedSearch = searchText
      .trim()
      .toLowerCase();

    return documents.filter(doc => {
      const matchesStatus =
        statusFilter === 'all' ||
        doc.status === statusFilter;

      const matchesCategory =
        category === 'all' ||
        doc.category.toLowerCase() ===
          category.toLowerCase();

      const matchesSearch =
        !normalizedSearch ||
        doc.name
          .toLowerCase()
          .includes(normalizedSearch);

      return (
        matchesStatus &&
        matchesCategory &&
        matchesSearch
      );
    });
  }, [
    statusFilter,
    category,
    searchText
  ]);

  const countByStatus = status => {
    if (status === 'all') {
      return documents.length;
    }

    return documents.filter(
      doc => doc.status === status
    ).length;
  };

  return (
    <Box sx={rootSx}>
      <PatientDocumentFilters
        searchText={searchText}
        category={category}
        dateRange={dateRange}
        statusFilter={statusFilter}
        countByStatus={countByStatus}
        onSearchChange={event =>
          setSearchText(event.target.value)
        }
        onCategoryChange={event =>
          setCategory(event.target.value)
        }
        onDateRangeChange={event =>
          setDateRange(event.target.value)
        }
        onStatusChange={setStatusFilter}
      />

      <PatientDocumentTable
        documents={filteredDocuments}
      />
    </Box>
  );
};

export default PatientDocumentList;